export default "__VITE_ASSET__DMPfRWoR__"